export default __webpack_public_path__ + "5b70d9f3791fa3dc2d822d51cb3982f7.png";